// extracted by mini-css-extract-plugin
export default {"checkout":"History_checkout__MotIa","checkout-top":"History_checkout-top__no5W8"};